export default {"src":"/_next/static/media/filters.12597329.svg","height":24,"width":24};